import _ from 'lodash'

import { SystemRoles } from '../../../lib/Codes'

export default function UserRoles ({ user }) {
  const role = _.get(user, 'app_metadata.roles.meta.role')

  const roleDisplay =
    (SystemRoles.find(r => r.value === role) || {}).label || '...'

  return <span className='user-role'>{roleDisplay}</span>
}
